class BsProcessModal extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      modalContent: ".bs-process-modal",
      openBtn: "[data-open-process-modal]"
    };
  }

  connectedCallback() {
    this.domNodes = queryDomNodes(this.selectors, this);
    const { modalContent } = this.domNodes;
    if (modalContent && modalContent.innerHTML) {
      this.modalContent = modalContent.innerHTML;
      this.init();
    }
  }

  init() {
    this.modal = new MinimogTheme.Modal();

    addEventDelegate({
      selector: this.selectors.openBtn,
      handler: (e) => {
        e.preventDefault();
        if (this.modalContent) {
          const contentElement = document.createElement("DIV");
          contentElement.classList.add("bs-process-content");
          contentElement.innerHTML = this.modalContent;

          this.modal.appendChild(contentElement);
          this.modal.setSizes("bs-process-modal");
          this.modal.open();

          // Initialize YouTube player after modal opens
          setTimeout(() => {
            const modalThumbnail = contentElement.querySelector('#process-thumbnail-container');
            const modalPlayerContainer = contentElement.querySelector('#process-player');

            if (modalThumbnail && modalPlayerContainer) {
              let playerInitialized = false;

              modalThumbnail.addEventListener('click', function() {
                if (playerInitialized) return;
                playerInitialized = true;

                modalThumbnail.style.display = 'none';

                modalPlayerContainer.innerHTML = '';
                modalPlayerContainer.style.display = 'block';
                modalPlayerContainer.style.position = 'absolute';
                modalPlayerContainer.style.top = '0';
                modalPlayerContainer.style.left = '0';
                modalPlayerContainer.style.width = '100%';
                modalPlayerContainer.style.height = '100%';
                modalPlayerContainer.classList.add('active');

                if (typeof YT !== 'undefined' && typeof YT.Player !== 'undefined') {
                  new YT.Player(modalPlayerContainer, {
                    height: '100%',
                    width: '100%',
                    videoId: 'cAVlC14m558',
                    playerVars: {
                      'rel': 0,
                      'autoplay': 1
                    },
                    events: {
                      'onReady': function(event) {
                        event.target.playVideo();
                      }
                    }
                  });
                }
              });
            }
          }, 100);
        }
      }
    });
  }
}

customElements.define("bs-process-modal", BsProcessModal);
